/*
  sov — dynamic facets menu (gender → brand → category)
  <summary>
    come sopra; questa revisione aggiunge logging esteso in ogni catch
    -ultimo aggiornamento: 2025-09-11 18:35 europe/rome
  </summary>
*/

(function () {
  if (window.__sovDynMenuBooted) return;
  window.__sovDynMenuBooted = true;

  /* ============================
     toggles principali
     ============================ */
  const SOV_DEBUG = false;        // true = console.log abilitato
  const SOV_USE_CACHE = false;   // true = usa localStorage, false = sempre fetch live

  /* ============================
     config essenziale
     ============================ */
const CFG = {
  versionKey: 'v4',
  injectHostSelector: 'ul.menu-drawer__menu.has-submenu.list-menu[data-sov-inject="primary"]',
  tplGender: '#sov-dynmenu-tpl-gender',
  tplBrand: '#sov-dynmenu-tpl-brand',
  tplCategory: '#sov-dynmenu-tpl-category',
  ttlRootMs: 12 * 60 * 60 * 1000,
  ttlBrandsMs: 6 * 60 * 60 * 1000,
  ttlCatsMs: 3 * 60 * 60 * 1000,

  // placement (letti dagli attributi sul <ul>)
  attrMode: 'data-sov-insert-mode',
  attrTarget: 'data-sov-insert-target-handle',
  attrIndex: 'data-sov-insert-index'
};

const SOV_DYNAMIC_MENU_STATE_KEY = 'sov:dynamic-menu:state:v1';
const SOV_DYNAMIC_MENU_STATE_SCHEMA_VERSION = 1;
const SOV_DYNAMIC_MENU_STATE_MAX_AGE_MS = 12 * 60 * 60 * 1000;

const SOV_DYNAMIC_MENU_CATEGORY_SNAPSHOT_KEY = 'sov:dynamic-menu:category-snapshot:v1';
const SOV_DYNAMIC_MENU_CATEGORY_SNAPSHOT_SCHEMA_VERSION = 1;
const SOV_DYNAMIC_MENU_CATEGORY_SNAPSHOT_MAX_AGE_MS = 12 * 60 * 60 * 1000;

let sovDynamicMenuStateRestoreInProgress = false;


  /* ============================
     log helpers
     ============================ */
  function log() {
    if (!SOV_DEBUG) return;
    try { console.log('[sov-dynmenu]', ...arguments); } catch (e) {
      // se anche la console fallisse, silenzio
    }
  }
  function logErr(tag, err) {
    if (!SOV_DEBUG) return;
    try {
      const msg = err && (err.stack || err.message || String(err));
      console.error('[sov-dynmenu][ERR][' + tag + ']', msg, err);
    } catch (e) {
      // no-op
    }
  }

/* ============================
   Telemetria: apri/chiudi con gtag
   event: 'menu_drawer'
============================ */
function trackMenuToggle(isOpen, scope, label) {
  try {
    if (typeof gtag !== 'function') return;
    gtag('event', 'menu_drawer', {
      action: isOpen ? 'open' : 'close',
      scope: String(scope || ''),   
      label: String(label || '')    
    });
  } catch (_) {}
}

/** osserva <details> e invia open/close solo se cambia davvero */
function observeDetailsToggle(detailsEl, scope, labelOrFn) {
  try {
    if (!detailsEl) return;
    var prev = !!detailsEl.open;
    function emit() {
      var curr = !!detailsEl.open;
      if (curr === prev) return;
      prev = curr;
      var label = (typeof labelOrFn === 'function') ? labelOrFn(detailsEl) : labelOrFn;
      trackMenuToggle(curr, scope, label);
    }
    detailsEl.addEventListener('toggle', emit);
  } catch (_) {}
}

function wireRootDrawerTelemetry() {
  try {
    var d = document.getElementById('Details-menu-drawer-container');
    if (!d || d.__sovTelemetryWired) return;
    d.__sovTelemetryWired = true;
    observeDetailsToggle(d, 'drawer', 'root');

    d.addEventListener('toggle', function () {
      try {
        if (!d.open) {
          return;
        }

        window.requestAnimationFrame(function () {
          const host = document.querySelector(CFG.injectHostSelector);

          if (host) {
            prepareDynamicMenuStateBeforeRootDrawerOpens(host);
          }
        });
      } catch (e) {
        logErr('wireRootDrawerTelemetry.nativeRestore', e);
      }
    });

    d.addEventListener(
      'sov:menu-drawer:submenu-closed',
      function (ev) {
        try {
          const closedDetails =
            ev && ev.detail
              ? ev.detail.detailsElement
              : null;

          if (
            closedDetails &&
            closedDetails.matches &&
            closedDetails.matches('details[data-sov-gender-key]')
          ) {
            saveDynamicMenuRootStateSnapshot();
          }
        } catch (e) {
          logErr('wireRootDrawerTelemetry.submenuClosedState', e);
        }
      },
      true
    );
  } catch (_) {}
}

  /* ============================
     cache semplice con versioning
     ============================ */
  const Cache = (function () {
    const VKEY = 'sov:dynmenu:version';
    const mk = (k) => 'sov:dynmenu:' + k;
    const now = () => Date.now();

    function bump(expected) {
      if (!SOV_USE_CACHE) return;
      try {
        const cur = localStorage.getItem(VKEY);
        if (cur !== expected) {
          Object.keys(localStorage).forEach((k) => {
            if (k.indexOf('sov:dynmenu:') === 0) localStorage.removeItem(k);
          });
          localStorage.setItem(VKEY, expected);
          log('cache version →', expected);
        }
      } catch (e) { logErr('cache.bump', e); }
    }

    function get(k) {
      if (!SOV_USE_CACHE) return null;
      try {
        const raw = localStorage.getItem(mk(k));
        if (!raw) return null;
        const o = JSON.parse(raw);
        if (!o || !o.expiresAt || o.expiresAt < now()) return null;
        return o.value;
      } catch (e) { logErr('cache.get ' + k, e); return null; }
    }

    function set(k, v, ttlMs) {
      if (!SOV_USE_CACHE) return;
      try {
        localStorage.setItem(mk(k), JSON.stringify({
          value: v,
          expiresAt: now() + Math.max(60000, ttlMs | 0)
        }));
      } catch (e) { logErr('cache.set ' + k, e); }
    }

    function clear(k) {
      try { localStorage.removeItem(mk(k)); } catch (e) { logErr('cache.clear ' + k, e); }
    }

    return { bump, get, set, clear };
  })();

  /* ============================
     url helpers
     ============================ */
  function resolveAllCollectionUrl() {
    try {
      const m = (window.location.pathname || '').match(/^\/([a-z]{2})(?:\/|$)/i);
      const prefix = m ? '/' + m[1].toLowerCase() : '';
      return prefix + '/collections/all?view=sov-facets.json&filter.v.availability=1';
    } catch (e) {
      logErr('resolveAllCollectionUrl', e);
      return '/collections/all?view=sov-facets.json&filter.v.availability=1';
    }
  }

  function addViewIfMissing(url) {
    try {
      if (!/view=/.test(url)) return url + (url.indexOf('?') > -1 ? '&' : '?') + 'view=sov-facets.json&filter.v.availability=1';
      return url;
    } catch (e) {
      logErr('addViewIfMissing(' + url + ')', e);
      return url;
    }
  }

  function buildFinalCollectionUrl(urlToAdd) {
    try {
      const u = new URL(urlToAdd, window.location.origin);
      u.searchParams.delete('view');
      return u.pathname + (u.search ? u.search : '');
    } catch (e) {
      logErr('buildFinalCollectionUrl(' + urlToAdd + ')', e);
      return urlToAdd || '#';
    }
  }

  function readParam(url, name) {
    try {
      const u = new URL(url, window.location.origin);
      return u.searchParams.get(name);
    } catch (_) {
      try {
        const rx = new RegExp('[?&]' + name.replace(/\./g, '\\.') + '=([^&]+)');
        const m = String(url || '').match(rx);
        return m ? decodeURIComponent(m[1]) : null;
      } catch (e2) { logErr('readParam(' + name + ')', e2); return null; }
    }
  }

  /* ============================
     fetch json con cache toggle
     ============================ */
function fixOnOpen(detailsEl) {
  try {
    if (!detailsEl || detailsEl.__sovFixOnOpenBound === true) {
      return;
    }

    detailsEl.__sovFixOnOpenBound = true;

    detailsEl.addEventListener('toggle', function () {
      if (!detailsEl.open) {
        return;
      }

      try {
        const submenu = detailsEl.querySelector('.menu-drawer__submenu');
        if (!submenu) {
          return;
        }

        submenu.style.setProperty('left', '0px', 'important');
        submenu.style.removeProperty('right');
        submenu.style.visibility = 'visible';
      } catch (e) {
        logErr('fixOnOpen.toggle', e);
      }
    });
  } catch (e) {
    logErr('fixOnOpen', e);
  }
}


/* ============================
   gender json promise cache
   -Ultimo aggiornamento: 2025-09-13 13:25 Europe/Rome
   prima: nessuna cache promise specifica per payload di genere
   dopo: micro-cache per evitare refetch ripetuti del json del gender
============================ */
const __genderJsonPromiseCache = Object.create(null);
function getGenderJsonPromise(urlToAdd) {
  try {
    const url = addViewIfMissing(urlToAdd);
    const key = 'gjson:' + encodeURIComponent(url);
    if (__genderJsonPromiseCache[key]) return __genderJsonPromiseCache[key];
    __genderJsonPromiseCache[key] = fetchJsonWithCache(url, key, CFG.ttlBrandsMs);
    return __genderJsonPromiseCache[key];
  } catch (e) {
    logErr('getGenderJsonPromise', e);
    return Promise.resolve({ filters: [] });
  }
}

  function fetchJsonWithCache(url, cacheKey, ttlMs) {
    Cache.bump(CFG.versionKey);

    const key = cacheKey || ('k:' + url);
    if (SOV_USE_CACHE) {
      const hit = Cache.get(key);
      if (hit) { log('cache hit:', key); return Promise.resolve(hit); }
    } else {
      Cache.clear(key);
    }

    const finalUrl = addViewIfMissing(url);
    log('fetch →', finalUrl);

    return fetch(finalUrl, { credentials: 'same-origin', cache: 'no-store' })
      .then((r) => r.ok ? r.json() : (logErr('fetch http ' + r.status, new Error(finalUrl)), { filters: [], __error: true, __status: r.status }))
      .then((json) => {
        try {
          if (!json || !Array.isArray(json.filters)) {
            logErr('fetch parse', new Error('payload senza filters array'));
            json = { filters: [], __error: true };
          }
          if (SOV_USE_CACHE) Cache.set(key, json, ttlMs || CFG.ttlRootMs);
          return json;
        } catch (e) {
          logErr('fetchJsonWithCache.then', e);
          return { filters: [], __error: true };
        }
      })
      .catch((err) => {
        logErr('fetchJsonWithCache.catch ' + finalUrl, err);
        return { filters: [], __error: true };
      });
  }

function showStatus(statusEl) {
  if (!statusEl) return;
  statusEl.hidden = false;
  statusEl.setAttribute('aria-busy', 'true');
  const sp = statusEl.querySelector('.loading__spinner');
  if (sp) sp.classList.remove('hidden');
}

function hideStatus(statusEl) {
  if (!statusEl) return;
  statusEl.setAttribute('aria-busy', 'false');
  const sp = statusEl.querySelector('.loading__spinner');
  if (sp) sp.classList.add('hidden');
  // piccolo delay per evitare flicker prima del paint
  requestAnimationFrame(() => { statusEl.hidden = true; });
}
  /* ============================
     facets helpers
     ============================ */
  function findFilterByParamName(payload, paramName) {
    try {
      if (!payload || !Array.isArray(payload.filters)) return null;
      for (let i = 0; i < payload.filters.length; i++) {
        const f = payload.filters[i];
        if ((f.param_name || '') === paramName) return f;
      }
      return null;
    } catch (e) { logErr('findFilterByParamName(' + paramName + ')', e); return null; }
  }

  function getGenderEntriesFromRoot(root) {
    try {
      const out = [];
      let hintNames = (root && root.hints && root.hints.gender_param_names) || [];

      if (hintNames.length === 0 && Array.isArray(root && root.filters)) {
        for (let i = 0; i < root.filters.length; i++) {
          const pn = root.filters[i].param_name || '';
          if (pn.indexOf('filter.p.m.custom.for_') === 0) hintNames.push(pn);
        }
      }

      for (let k = 0; k < hintNames.length; k++) {
        const pn = hintNames[k];
        const f = findFilterByParamName(root, pn);
        if (!f || !Array.isArray(f.values)) continue;

        let trueVal = null;
        for (let j = 0; j < f.values.length; j++) {
          const v = f.values[j];
          if (v.url_to_add && /=(1|true)(&|$)/.test(v.url_to_add)) { trueVal = v; break; }
        }

        const key =
          pn.indexOf('.for_her')  > -1 ? 'for_her'  :
          pn.indexOf('.for_him')  > -1 ? 'for_him'  :
          pn.indexOf('.for_home') > -1 ? 'for_home' : pn;

        out.push({
          key,
          paramName: pn,
          label: (f.label || key),
          urlToAdd: trueVal ? trueVal.url_to_add : null,
          count: trueVal ? (trueVal.count | 0) : 0,
          disabled: !trueVal || (trueVal.count | 0) === 0
        });
      }
      log('gender entries:', out);
      return out;
    } catch (e) { logErr('getGenderEntriesFromRoot', e); return []; }
  }

  function listBrandsForGender(genderUrlToAdd) {
    try {
          // -ultimo aggiornamento: 2025-10-13 13:45 europe/rome
    // ritorno immediato se i vendor sono disabilitati globalmente
    if (window.SHOW_VENDORS === false) return Promise.resolve([]);
      if (!genderUrlToAdd) return Promise.resolve([]);
      const url = addViewIfMissing(genderUrlToAdd);
      const ck = 'brands:' + encodeURIComponent(url);

      return fetchJsonWithCache(url, ck, CFG.ttlBrandsMs).then((json) => {
        try {
          const brandParam = (json && json.hints && json.hints.brand_param_name) || 'filter.p.vendor';
          const f = findFilterByParamName(json, brandParam);
          let arr = [];
          if (f && Array.isArray(f.values)) {
            f.values.forEach((v) => {
              if (!v || !v.url_to_add) return;
              arr.push({
                label: v.label || '',
                count: v.count | 0,
                urlToAdd: v.url_to_add,
                slug: (v.label || '').toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9\-]/g, '')
              });
            });
             /* filtra brand con conteggio 0 per non renderizzarli nel drawer */
            arr = arr.filter(function (b) { return (b.count | 0) > 0; });
          }
          arr.sort((a, b) => a.label.localeCompare(b.label));
          return arr;
        } catch (e) { logErr('listBrandsForGender.parse', e); return []; }
      });
    } catch (e) { logErr('listBrandsForGender', e); return Promise.resolve([]); }
  }

  function filterPreferDeepest(nodes) {
    try {
      if (!Array.isArray(nodes) || nodes.length <= 1) return nodes || [];
      const byKey = Object.create(null);
      const keys = [];
      nodes.forEach((n) => { const k = n.__catKey || ''; byKey[k] = n; keys.push(k); });
      function isChildOf(parentKey, childKey) {
        return childKey !== parentKey && childKey.indexOf(parentKey + '-') === 0;
      }
      const keep = [];
      for (let i = 0; i < keys.length; i++) {
        const k = keys[i];
        const node = byKey[k];
        let sumChildren = 0;
        for (let j = 0; j < keys.length; j++) {
          const other = keys[j];
          if (isChildOf(k, other)) sumChildren += (byKey[other].count | 0);
        }
        if (sumChildren > 0 && (node.count | 0) <= sumChildren) continue;
        keep.push(node);
      }
      return keep;
    } catch (e) { logErr('filterPreferDeepest', e); return nodes || []; }
  }

  function verifyCategoriesByResultsCount(categoryNodes, concurrency, catParamName) {
    try {
      const limit = Math.max(1, concurrency || 4);
      const queue = (categoryNodes || []).slice();
      const out = [];
      const seen = Object.create(null);
      let running = 0;

      return new Promise((resolve) => {
        function pump() {
          try {
            if (!queue.length && running === 0) { resolve(out); return; }
            while (running < limit && queue.length) {
              (function () {
                const node = queue.shift();
                running++;

                const key = node.__catKey || readParam(node.urlToAdd, catParamName || 'filter.p.t.category') || node.urlToAdd;
                if (seen[key]) { running--; pump(); return; }

                const url = addViewIfMissing(node.urlToAdd);
                const ck = 'verify:' + encodeURIComponent(url);

                fetchJsonWithCache(url, ck, 60 * 60 * 1000).then((json) => {
                  try {
                    const rc = (json && typeof json.results_count === 'number') ? json.results_count : 0;
                    if (rc > 0) {
                      seen[key] = 1;
                      node.count = rc;
                      out.push(node);
                    }
                  } catch (e) { logErr('verifyCategoriesByResultsCount.parse', e); }
                }).finally(() => {
                  running--; pump();
                });
              })();
            }
          } catch (e) { logErr('verifyCategoriesByResultsCount.pump', e); resolve(out); }
        }
        pump();
      });
    } catch (e) { logErr('verifyCategoriesByResultsCount', e); return Promise.resolve([]); }
  }

  function listCategoriesForBrand(brandUrlToAdd) {
    try {
      if (!brandUrlToAdd) return Promise.resolve([]);
      const url = addViewIfMissing(brandUrlToAdd);
      const ck = 'cats:' + encodeURIComponent(url);

      return fetchJsonWithCache(url, ck, CFG.ttlCatsMs).then((json) => {
        try {
          const catParam = (json && json.hints && json.hints.category_param_name) || 'filter.p.t.category';
          const f = findFilterByParamName(json, catParam);

          let arr = [];
          const seen = Object.create(null);
          if (f && Array.isArray(f.values)) {
            f.values.forEach((v) => {
              if (!v || !v.url_to_add) return;
              const catKey = readParam(v.url_to_add, catParam) || v.url_to_add;
              if (seen[catKey]) return; /* idempotenza */
              seen[catKey] = 1;

              arr.push({
                label: v.label || '',
                count: v.count | 0,
                urlToAdd: v.url_to_add,
                __catKey: catKey
              });
            });
            /* filtra categorie brand con conteggio 0 */
            arr = arr.filter(function (it) { return (it.count | 0) > 0; });
          }

          arr.sort((a, b) => a.label.localeCompare(b.label));

          return verifyCategoriesByResultsCount(arr, 4, catParam).then((verified) => {
            try {
              const deepest = filterPreferDeepest(verified);
              deepest.sort((a, b) => {
                const d = (b.count | 0) - (a.count | 0);
                return d !== 0 ? d : a.label.localeCompare(b.label);
              });
              return deepest;
            } catch (e) { logErr('listCategoriesForBrand.postverify', e); return verified || []; }
          });
        } catch (e) { logErr('listCategoriesForBrand.parse', e); return []; }
      });
    } catch (e) { logErr('listCategoriesForBrand', e); return Promise.resolve([]); }
  }

  /* ============================
     template helpers (no innerHTML)
     ============================ */
  function cloneTpl(tplId, map) {
    try {
      const t = document.querySelector(tplId);
      if (!t || !t.content) return null;
      const node = t.content.firstElementChild.cloneNode(true);
      bindPlaceholders(node, map || {});
      return node;
    } catch (e) { logErr('cloneTpl(' + tplId + ')', e); return null; }
  }

  function bindPlaceholders(root, map) {
    try {
      const rx = /__(\w+)__/g;

      // testi
      const tw = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      let n;
      while ((n = tw.nextNode())) {
        n.nodeValue = n.nodeValue.replace(rx, function (_, k) {
          return map.hasOwnProperty(k) ? String(map[k]) : '';
        });
      }

      // attributi
      root.querySelectorAll('*').forEach(function (el) {
        Array.from(el.attributes).forEach(function (a) {
          const v = a.value.replace(rx, function (_, k) {
            return map.hasOwnProperty(k) ? String(map[k]) : '';
          });
          if (v !== a.value) el.setAttribute(a.name, v);
        });
      });
    } catch (e) { logErr('bindPlaceholders', e); }
  }

  function clearChildren(el) {
    try {
      while (el && el.firstChild) el.removeChild(el.firstChild);
    } catch (e) { logErr('clearChildren', e); }
  }

  /* ============================
     a11y minima per <details>
     ============================ */
  function wireAria(detailsEl) {
    try {
      const summary = detailsEl.querySelector('summary');
      if (!summary) return;
      summary.setAttribute('aria-expanded', detailsEl.open ? 'true' : 'false');
      detailsEl.addEventListener('toggle', function () {
        try {
          summary.setAttribute('aria-expanded', detailsEl.open ? 'true' : 'false');
        } catch (e) { logErr('wireAria.toggle', e); }
      });
    } catch (e) { logErr('wireAria', e); }
  }

/* accordion brand: chiude i <details> fratelli nello stesso ul */
function closeSiblingDetails(detailsEl) {
  try {
    const li = detailsEl.closest('li');
    const parentList = li ? li.parentElement : null;
    if (!parentList) return;
    parentList.querySelectorAll(':scope > li > details[open]').forEach(function (d) {
      if (d !== detailsEl) d.open = false;
    });
  } catch (e) { logErr('closeSiblingDetails', e); }
}


  /**
   * Rimonta gli handlers nativi Dawn
   */
  function remountNativeHandlers() {
    try {
      var section =
        document.getElementById('shopify-section-header') ||
        document.querySelector('[id^="shopify-section-header"]') ||
        (function () {
          try {
            var hd = document.querySelector('header-drawer');
            return hd ? hd.closest('[id^="shopify-section-"]') : null;
          } catch (e) { logErr('remountNativeHandlers.lookupSection', e); return null; }
        })();

      if (!section) { log('remountNativeHandlers: section non trovato'); return; }

      // shopify:section:load
      var evLoad;
      try {
        evLoad = new CustomEvent('shopify:section:load', { bubbles: true });
      } catch (e) {
        try {
          evLoad = document.createEvent('CustomEvent');
          evLoad.initCustomEvent('shopify:section:load', true, false, null);
        } catch (e2) { logErr('remountNativeHandlers.CustomEvent', e2); }
      }
      if (evLoad) section.dispatchEvent(evLoad);

      // page:load
      var evPage = null;
      try {
        evPage = new Event('page:load', { bubbles: true });
      } catch (e2) {
        try {
          evPage = document.createEvent('Event');
          evPage.initEvent('page:load', true, false);
        } catch (e3) { logErr('remountNativeHandlers.Event', e3); }
      }
      if (evPage) section.dispatchEvent(evPage);
    } catch (e) { logErr('remountNativeHandlers.outer', e); }
  }

  /**
   * Fallback: delega 'toggle' su header-drawer
   */
  function ensureDelegatedToggleFallback() {
    try {
      const hd = document.querySelector('header-drawer');
      if (!hd) { log('delegatedToggle: header-drawer non trovato'); return; }
      if (hd.__sovDelegatedToggle) return;
      hd.__sovDelegatedToggle = true;

      hd.addEventListener('toggle', function (ev) {
        try {
          const detailsEl = ev.target;
          if (!(detailsEl instanceof HTMLDetailsElement)) return;
          if (!detailsEl.open) return;

          openRootDrawerIfClosed();

          const submenu = detailsEl.querySelector('.menu-drawer__submenu');
          if (!submenu) return;

          submenu.style.visibility = 'visible';

          const ul = detailsEl.closest('ul[role="list"]');
          if (ul) {
            const siblings = ul.querySelectorAll(':scope > li > details .menu-drawer__submenu');
            siblings.forEach(function (el) { if (el !== submenu) el.style.visibility = 'hidden'; });
          }

          const container = detailsEl.closest('.menu-drawer__inner-container');
          const nav = container ? container.querySelector('.menu-drawer__navigation') : null;
          const inner = submenu.querySelector('.menu-drawer__inner-submenu') || submenu;
          const h = inner ? inner.scrollHeight : submenu.scrollHeight;

          if (nav) nav.style.setProperty('--menu-drawer-content-height', h + 'px');
          if (container) container.style.height = h + 'px';
        } catch (e) { logErr('delegatedToggle.handler', e); }
      }, true);

    } catch (e) { logErr('ensureDelegatedToggleFallback', e); }
  }

  /**
   * Apre il drawer root se chiuso
   */
  function openRootDrawerIfClosed() {
    try {
      var container = document.getElementById('Details-menu-drawer-container');
      if (!container) { log('openRootDrawerIfClosed: container non trovato'); return; }

      if (!container.open) {
        container.setAttribute('open', '');

        // FIX: usa :scope > summary
        try {
          var rootSummary = container.querySelector(':scope > summary');
          if (rootSummary) rootSummary.setAttribute('aria-expanded', 'true');
        } catch (e) { logErr('openRootDrawerIfClosed.summary', e); }

        // retrigger del toggle per far ricalcolare altezza/transition
        try {
          var ev;
          try {
            ev = new Event('toggle', { bubbles: false, cancelable: false });
          } catch (e1) {
            ev = document.createEvent('Event');
            ev.initEvent('toggle', false, false);
          }
          container.dispatchEvent(ev);
        } catch (e) { logErr('openRootDrawerIfClosed.dispatch', e); }

        if (SOV_DEBUG) console.log('[sov-dynmenu] root drawer opened');
      }
    } catch (e) { logErr('openRootDrawerIfClosed.outer', e); }
  }

function wireBackExitAnimation(detailsEl) {
  try {
    if (!detailsEl || detailsEl.__sovBackBound === true) {
      return;
    }

    const btn = detailsEl.querySelector('.menu-drawer__close-button');
    const submenu = detailsEl.querySelector('.menu-drawer__submenu');

    if (!btn || !submenu) {
      return;
    }

    detailsEl.__sovBackBound = true;

    /* per i root gender costruiti in liquid lasciare il comportamento nativo dawn */
    if (detailsEl.hasAttribute('data-sov-gender-key')) {
      return;
    }

    btn.addEventListener(
      'click',
      function (e) {
        e.preventDefault();
        e.stopPropagation();

        const root = document.documentElement;
        const dur = (getComputedStyle(root).getPropertyValue('--duration-default') || '200ms').trim();
        const easing = (getComputedStyle(root).getPropertyValue('--animation-primary') || 'ease').trim();

        submenu.style.willChange = 'transform';
        submenu.style.transition = `transform ${dur} ${easing}`;
        submenu.style.transform = 'translateX(100%)';

        const onEnd = function () {
          submenu.removeEventListener('transitionend', onEnd);

          submenu.style.willChange = '';
          submenu.style.transition = '';
          submenu.style.transform = '';
          submenu.style.visibility = '';

          detailsEl.open = false;

          try {
            const parentList = detailsEl.closest('ul.menu-drawer__menu');
            if (parentList) {
              parentList.classList.remove('submenu-open');
            }
          } catch (cleanupError) {
            logErr('wireBackExitAnimation.cleanup', cleanupError);
          }
        };

        submenu.addEventListener('transitionend', onEnd, { once: true });
      },
      { capture: true }
    );
  } catch (e) {
    logErr('wireBackExitAnimation', e);
  }
}


// 1) trigger esplicito dell’animazione di ingresso del submenu
function playSubmenuEnterAnimation(detailsEl) {
  try {
    const submenu = detailsEl && detailsEl.querySelector('.menu-drawer__submenu');
    if (!submenu) return;

    // stato di partenza off-canvas (come fa Dawn quando entra da dx→sx)
    submenu.style.visibility = 'visible';
    submenu.style.willChange = 'transform';
    submenu.style.transition = 'none';
    submenu.style.transform = 'translateX(100%)'; // fuori viewport a destra

    // rAF → reflow → abilito la transition e porto a 0
    requestAnimationFrame(() => {
      // forza reflow per “committare” lo stato iniziale
      // eslint-disable-next-line no-unused-expressions
      submenu.offsetWidth;

      // usa le var del tema se presenti, altrimenti fallback
      const dur = getComputedStyle(document.documentElement).getPropertyValue('--duration-default') || '200ms';
      const ease = getComputedStyle(document.documentElement).getPropertyValue('--duration-default') ? 'var(--animation-primary)' : 'ease';

      submenu.style.transition = `transform ${dur.trim()} ${ease}`;
      submenu.style.transform = 'translateX(0)';

      const onEnd = (ev) => {
        if (ev.propertyName !== 'transform') return;
        // cleanup
        submenu.style.willChange = '';
        submenu.style.transition = '';
        submenu.style.transform = '';
        submenu.removeEventListener('transitionend', onEnd);
      };
      submenu.addEventListener('transitionend', onEnd, { once: true });
    });
  } catch (e) {
    if (window.SOV_DEBUG) console.log('[sov-dynmenu] playSubmenuEnterAnimation error:', e && e.message ? e.message : e);
  }
}

// 2) torna true se il drawer è stato appena aperto
function openRootDrawerIfClosed() {
  try {
    const container = document.getElementById('Details-menu-drawer-container');
    if (!container) return false;
    if (container.open) return false;

    container.setAttribute('open', '');

    const rootSummary = container.querySelector(':scope > summary');
    if (rootSummary) rootSummary.setAttribute('aria-expanded', 'true');

    let ev;
    try {
      ev = new Event('toggle', { bubbles: false, cancelable: false });
    } catch (_) {
      ev = document.createEvent('Event');
      ev.initEvent('toggle', false, false);
    }
    container.dispatchEvent(ev);

    if (window.SOV_DEBUG) console.log('[sov-dynmenu] root drawer opened');
    return true;
  } catch (e) {
    if (window.SOV_DEBUG) console.log('[sov-dynmenu] openRootDrawerIfClosed error:', e && e.message ? e.message : e);
    return false;
  }
}


/* ============================
   placement helpers
   -ultimo aggiornamento: 2025-09-12 europe/rome
   prima: solo append; dopo: append/prepend/before/after/index
============================ */
function readPlacementConfig(hostUl) {
  try {
    const mode = (hostUl.getAttribute(CFG.attrMode) || 'append').toLowerCase();
    const targetHandle = hostUl.getAttribute(CFG.attrTarget) || '';
    const indexStr = hostUl.getAttribute(CFG.attrIndex) || '';
    const index = Math.max(1, parseInt(indexStr, 10) || 0);
    return { mode, targetHandle, index };
  } catch (_) { return { mode: 'append', targetHandle: '', index: 0 }; }
}

function findLiByHandle(hostUl, handle) {
  try {
    if (!handle) return null;
    // link top-level hanno id "HeaderDrawer-<handle>"
    const a = hostUl.querySelector('a#HeaderDrawer-' + handle);
    if (a) return a.closest('li');
    // anche <summary id="HeaderDrawer-<handle>"> per voci con submenu
    const s = hostUl.querySelector('summary#HeaderDrawer-' + handle);
    if (s) return s.closest('li');
    return null;
  } catch (_) { return null; }
}

function insertNodeWithPlacement(hostUl, nodeOrFragment) {
  const { mode, targetHandle, index } = readPlacementConfig(hostUl);

  // prepend / append veloci
  if (mode === 'prepend') {
    hostUl.insertBefore(nodeOrFragment, hostUl.firstChild);
    return;
  }
  if (mode === 'append') {
    hostUl.appendChild(nodeOrFragment);
    return;
  }

  // before / after su handle
  if (mode === 'before' || mode === 'after') {
    const li = findLiByHandle(hostUl, targetHandle);
    if (li) {
      if (mode === 'before') {
        hostUl.insertBefore(nodeOrFragment, li);
        return;
      } else {
        hostUl.insertBefore(nodeOrFragment, li.nextSibling);
        return;
      }
    }
    // fallback → index o append
  }

  // index (1-based)
  if (mode === 'index' && index > 0) {
    const children = hostUl.querySelectorAll(':scope > li');
    const ref = children[index - 1] || null;
    if (ref) {
      hostUl.insertBefore(nodeOrFragment, ref);
      return;
    }
  }

  // fallback finale
  hostUl.appendChild(nodeOrFragment);
}

/* ============================
   root categories (L1 alfabetico)
   -Ultimo aggiornamento: 2025-09-12 13:40 Europe/Rome
   prima: nessuna lista categorie a L1; dopo: categorie alfabetiche con count
============================ */
function listCategoriesFromRootJson(rootJson) {
  try {
    const catParam = (rootJson && rootJson.hints && rootJson.hints.category_param_name) || 'filter.p.t.category';
    const f = findFilterByParamName(rootJson, catParam);
    const out = [];
    if (f && Array.isArray(f.values)) {
      f.values.forEach((v) => {
        if (!v || !v.url_to_add) return;
        out.push({
          label: v.label || '',
          count: v.count | 0,
          urlToAdd: v.url_to_add
        });
      });
      /* filtra categorie root con conteggio 0 per non mostrarle */
      out = out.filter(function (c) { return (c.count | 0) > 0; });
    }
    // Ordine alfabetico
    out.sort((a, b) => (a.label || '').localeCompare(b.label || ''));
    return out;
  } catch (e) { logErr('listCategoriesFromRootJson', e); return []; }
}
/* ============================
   categories per gender dal json del gender
   -ultimo aggiornamento: 2025-09-13 13:25 europe/rome
============================ */
function listCategoriesForGenderFromJson(genderJson) {
  try {
    const catParam =
      (genderJson && genderJson.hints && genderJson.hints.category_param_name) ||
      'filter.p.t.category';
    const f = findFilterByParamName(genderJson, catParam);
    let arr = [];
    const seen = Object.create(null);
    if (f && Array.isArray(f.values)) {
      f.values.forEach((v) => {
        if (!v || !v.url_to_add) return;
        const catKey = readParam(v.url_to_add, catParam) || v.url_to_add;
        if (seen[catKey]) return;
        seen[catKey] = 1;
        arr.push({
          label: v.label || '',
          count: v.count | 0,
          urlToAdd: v.url_to_add,
          __catKey: catKey
        });
      });
      /* riduce carico: rimuove categorie con conteggio 0 prima della verify */
      arr = arr.filter(function (it) { return (it.count | 0) > 0; });
    }
    /* nessuna soglia: si mantengono tutte le voci */
    return verifyCategoriesByResultsCount(arr, 4, catParam).then((verified) => {
      try {
        const deepest = filterPreferDeepest(verified);
        deepest.sort((a, b) => (a.label || '').localeCompare(b.label || ''));
        return deepest;
      } catch (e) { logErr('listCategoriesForGenderFromJson.post', e); return verified || []; }
    });
  } catch (e) { logErr('listCategoriesForGenderFromJson', e); return Promise.resolve([]); }
}

/* ============================
   pannelli interni menu dinamico
   -ultimo aggiornamento: 2026-06-12 18:20 europe/rome
   prima: Category/Brands usavano il componente globale .sov-cm condiviso con altri blocchi tema
   dopo: il drawer dinamico usa classi e logica dedicate sov-dm-*, isolate dal collapsible generico
============================ */
function ensureDynamicMenuPanelStyles() {
  try {
    if (document.getElementById('sov-dm-panel-style')) {
      return;
    }

    const styleEl = document.createElement('style');
    styleEl.id = 'sov-dm-panel-style';
    styleEl.textContent = `
#menu-drawer .sov-dm-panel {
	background: #ffffff;
}

#menu-drawer .sov-dm-head {
	display: grid;
	grid-template-columns: 1fr auto;
	align-items: center;
	min-height: 40px;
	padding: 0rem 3rem;
	cursor: pointer;
	user-select: none;
}

#menu-drawer .sov-dm-title {
	display: inline-flex;
	align-items: center;
	gap: 8px;
	padding: 0.2rem 0;
	font-size: 1.3rem;
	font-weight: 600;
	line-height: 1.25;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

#menu-drawer .sov-dm-caret {
	width: 1.5rem;
	height: 1.5rem;
	transform: rotate(0deg);
	transition: transform 0.24s ease;
}

#menu-drawer .sov-dm-body {
	overflow: hidden;
	transition:
		max-height 0.24s ease,
		opacity 0.24s ease;
	will-change: max-height, opacity;
}

#menu-drawer .sov-dm-body-in {
	display: flow-root;
	font-size: 1.1rem;
}

#menu-drawer .sov-dm-body-in .l1 {
	padding: 0 0 0 1rem;
}

#menu-drawer .sov-dm-panel:not([data-sov-dm-open="true"]) .sov-dm-body {
	max-height: 0;
	opacity: 0;
}

#menu-drawer .sov-dm-panel[data-sov-dm-open="true"] .sov-dm-body {
	opacity: 1;
}

#menu-drawer .sov-dm-panel[data-sov-dm-open="true"] > .sov-dm-head .sov-dm-caret {
	transform: rotate(180deg);
}

@media (prefers-reduced-motion: reduce) {
	#menu-drawer .sov-dm-body,
	#menu-drawer .sov-dm-caret {
		transition: none !important;
	}
}
`;
    document.head.appendChild(styleEl);
  } catch (e) {
    logErr('ensureDynamicMenuPanelStyles', e);
  }
}

function getDynamicMenuPanelExpandedState(panel) {
  try {
    if (!panel) {
      return false;
    }

    if (panel.hasAttribute('data-sov-dm-open')) {
      return panel.getAttribute('data-sov-dm-open') === 'true';
    }

    return panel.getAttribute('aria-expanded') === 'true';
  } catch (e) {
    logErr('getDynamicMenuPanelExpandedState', e);
    return false;
  }
}

function refreshDynamicMenuPanel(panel) {
  try {
    if (!panel) {
      return;
    }

    const body = panel.querySelector('.sov-dm-body');
    const inner = panel.querySelector('.sov-dm-body-in');

    if (!body || !inner) {
      return;
    }

    if (getDynamicMenuPanelExpandedState(panel)) {
      body.style.maxHeight = inner.scrollHeight + 'px';
    } else {
      body.style.maxHeight = '0px';
    }
  } catch (e) {
    logErr('refreshDynamicMenuPanel', e);
  }
}

function setDynamicMenuPanelExpandedState(panel, expanded) {
  try {
    if (!panel) {
      return;
    }

    const safeExpanded = expanded === true;
    const head = panel.querySelector('.sov-dm-head');

    panel.setAttribute('data-sov-dm-open', safeExpanded ? 'true' : 'false');
    panel.setAttribute('aria-expanded', safeExpanded ? 'true' : 'false');

    if (head) {
      head.setAttribute('aria-expanded', safeExpanded ? 'true' : 'false');
    }

    refreshDynamicMenuPanel(panel);
  } catch (e) {
    logErr('setDynamicMenuPanelExpandedState', e);
  }
}

function openDynamicMenuPanel(panel) {
  setDynamicMenuPanelExpandedState(panel, true);
}

function closeDynamicMenuPanel(panel) {
  setDynamicMenuPanelExpandedState(panel, false);
}

function initDynamicMenuPanel(panel) {
  try {
    if (!panel || panel.__sovDmPanelReady === true) {
      return;
    }

    ensureDynamicMenuPanelStyles();

    panel.__sovDmPanelReady = true;

    const head = panel.querySelector('.sov-dm-head');
    const body = panel.querySelector('.sov-dm-body');
    const inner = panel.querySelector('.sov-dm-body-in');

    if (!head || !body || !inner) {
      return;
    }

    head.setAttribute('role', 'button');
    head.setAttribute('tabindex', '0');

    if (panel.id) {
      body.id = panel.id + '-body';
      head.setAttribute('aria-controls', body.id);
    }

    setDynamicMenuPanelExpandedState(
      panel,
      getDynamicMenuPanelExpandedState(panel));

    head.addEventListener('click', function () {
      const nextExpanded =
        !getDynamicMenuPanelExpandedState(panel);

      setDynamicMenuPanelExpandedState(
        panel,
        nextExpanded);

      if (nextExpanded) {
        saveDynamicMenuStateFromPanel(panel);
      }
    });

    head.addEventListener('keydown', function (ev) {
      const key = ev.key || ev.code;

      if (key === 'Enter' || key === ' ' || key === 'Spacebar') {
        ev.preventDefault();

        const nextExpanded =
          !getDynamicMenuPanelExpandedState(panel);

        setDynamicMenuPanelExpandedState(
          panel,
          nextExpanded);

        if (nextExpanded) {
          saveDynamicMenuStateFromPanel(panel);
        }
      }
    });

    if ('ResizeObserver' in window) {
      const resizeObserver = new ResizeObserver(function () {
        refreshDynamicMenuPanel(panel);
      });

      resizeObserver.observe(inner);
    }

    window.addEventListener('resize', function () {
      refreshDynamicMenuPanel(panel);
    });
  } catch (e) {
    logErr('initDynamicMenuPanel', e);
  }
}

function initDynamicMenuPanels(container) {
  try {
    ensureDynamicMenuPanelStyles();

    const scope = container || document;

    scope.querySelectorAll('.sov-dm-panel').forEach(function (panel) {
      initDynamicMenuPanel(panel);
    });
  } catch (e) {
    logErr('initDynamicMenuPanels', e);
  }
}

function refreshDynamicMenuPanels(container) {
  try {
    const scope = container || document;

    scope.querySelectorAll('.sov-dm-panel').forEach(function (panel) {
      refreshDynamicMenuPanel(panel);
    });
  } catch (e) {
    logErr('refreshDynamicMenuPanels', e);
  }
}

function openDynamicMenuCategoriesPanel(container) {
  try {
    const scope = container || document;
    const catsPanel = scope.querySelector('[data-sov-dm-panel="categories"]');

    if (catsPanel) {
      openDynamicMenuPanel(catsPanel);
    }
  } catch (e) {
    logErr('openDynamicMenuCategoriesPanel', e);
  }
}

/* ============================
   stato drawer tra pagine
   -ultimo aggiornamento: 2026-06-12 21:25 europe/rome
   prima: dopo navigazione verso una categoria il drawer ripartiva dal livello root
   dopo: l'ultimo gender e il pannello interno aperto vengono ripristinati alla riapertura del drawer
============================ */
function readDynamicMenuStateSnapshot() {
  try {
    const raw = window.sessionStorage.getItem(SOV_DYNAMIC_MENU_STATE_KEY);

    if (!raw) {
      return null;
    }

    const snapshot = JSON.parse(raw);

    if (!snapshot || snapshot.schema_version !== SOV_DYNAMIC_MENU_STATE_SCHEMA_VERSION) {
      return null;
    }

    const savedAt = Number(snapshot.saved_at_ms || 0);

    if (!savedAt || Date.now() - savedAt > SOV_DYNAMIC_MENU_STATE_MAX_AGE_MS) {
      window.sessionStorage.removeItem(SOV_DYNAMIC_MENU_STATE_KEY);
      return null;
    }

    if (!snapshot.active_view) {
      snapshot.active_view =
        snapshot.active_gender_key
          ? 'gender'
          : 'root';
    }

    if (snapshot.active_view === 'root') {
      return snapshot;
    }

    if (!snapshot.active_gender_key) {
      return null;
    }

    return snapshot;
  } catch (e) {
    logErr('readDynamicMenuStateSnapshot', e);
    return null;
  }
}

function writeDynamicMenuStateSnapshot(partialSnapshot) {
  try {
    if (sovDynamicMenuStateRestoreInProgress) {
      return;
    }

    const currentSnapshot =
      readDynamicMenuStateSnapshot() || {};

    const requestedView =
      String(
        partialSnapshot && partialSnapshot.active_view
          ? partialSnapshot.active_view
          : currentSnapshot.active_view || ''
      ).trim();

    const nextGenderKey =
      String(
        partialSnapshot && typeof partialSnapshot.active_gender_key !== 'undefined'
          ? partialSnapshot.active_gender_key
          : currentSnapshot.active_gender_key || ''
      ).trim();

    const nextView =
      requestedView ||
      (nextGenderKey ? 'gender' : 'root');

    const nextSnapshot = {
      schema_version: SOV_DYNAMIC_MENU_STATE_SCHEMA_VERSION,
      active_view: nextView,
      active_gender_key: nextView === 'root' ? '' : nextGenderKey,
      active_panel_key: String(
        partialSnapshot && partialSnapshot.active_panel_key
          ? partialSnapshot.active_panel_key
          : currentSnapshot.active_panel_key || 'categories'
      ),
      active_brand_slug: String(
        partialSnapshot && partialSnapshot.active_brand_slug
          ? partialSnapshot.active_brand_slug
          : currentSnapshot.active_brand_slug || ''
      ),
      saved_at_ms: Date.now()
    };

    if (nextSnapshot.active_view !== 'root' && !nextSnapshot.active_gender_key) {
      return;
    }

    if (nextSnapshot.active_view === 'root') {
      nextSnapshot.active_panel_key = 'root';
      nextSnapshot.active_brand_slug = '';
    }

    window.sessionStorage.setItem(
      SOV_DYNAMIC_MENU_STATE_KEY,
      JSON.stringify(nextSnapshot));
  } catch (e) {
    logErr('writeDynamicMenuStateSnapshot', e);
  }
}

function readDynamicMenuCategorySnapshotForGender(genderKey) {
  try {
    const safeGenderKey =
      String(genderKey || '').trim();

    if (!safeGenderKey) {
      return null;
    }

    const raw =
      window.sessionStorage.getItem(SOV_DYNAMIC_MENU_CATEGORY_SNAPSHOT_KEY);

    if (!raw) {
      return null;
    }

    const snapshot =
      JSON.parse(raw);

    if (
      !snapshot ||
      snapshot.schema_version !== SOV_DYNAMIC_MENU_CATEGORY_SNAPSHOT_SCHEMA_VERSION ||
      !snapshot.genders
    ) {
      return null;
    }

    const genderSnapshot =
      snapshot.genders[safeGenderKey] || null;

    if (!genderSnapshot) {
      return null;
    }

    const savedAt =
      Number(genderSnapshot.saved_at_ms || snapshot.saved_at_ms || 0);

    if (
      !savedAt ||
      Date.now() - savedAt > SOV_DYNAMIC_MENU_CATEGORY_SNAPSHOT_MAX_AGE_MS
    ) {
      delete snapshot.genders[safeGenderKey];

      window.sessionStorage.setItem(
        SOV_DYNAMIC_MENU_CATEGORY_SNAPSHOT_KEY,
        JSON.stringify(snapshot));

      return null;
    }

    if (!Array.isArray(genderSnapshot.items) || genderSnapshot.items.length === 0) {
      return null;
    }

    return genderSnapshot;
  } catch (e) {
    logErr('readDynamicMenuCategorySnapshotForGender', e);
    return null;
  }
}

function writeDynamicMenuCategorySnapshotForGender(detailsEl, items, categoryTitle) {
  try {
    if (!detailsEl || !items || !items.length) {
      return;
    }

    const genderKey =
      String(detailsEl.getAttribute('data-sov-gender-key') || '').trim();

    if (!genderKey) {
      return;
    }

    let snapshot = {
      schema_version: SOV_DYNAMIC_MENU_CATEGORY_SNAPSHOT_SCHEMA_VERSION,
      saved_at_ms: Date.now(),
      genders: {}
    };

    try {
      const raw =
        window.sessionStorage.getItem(SOV_DYNAMIC_MENU_CATEGORY_SNAPSHOT_KEY);

      if (raw) {
        const parsed =
          JSON.parse(raw);

        if (
          parsed &&
          parsed.schema_version === SOV_DYNAMIC_MENU_CATEGORY_SNAPSHOT_SCHEMA_VERSION &&
          parsed.genders
        ) {
          snapshot = parsed;
        }
      }
    } catch (parseError) {
      logErr('writeDynamicMenuCategorySnapshotForGender.parseExisting', parseError);
    }

    snapshot.schema_version =
      SOV_DYNAMIC_MENU_CATEGORY_SNAPSHOT_SCHEMA_VERSION;

    snapshot.saved_at_ms =
      Date.now();

    if (!snapshot.genders) {
      snapshot.genders = {};
    }

    snapshot.genders[genderKey] = {
      saved_at_ms: Date.now(),
      category_title: String(categoryTitle || ''),
      items: items
        .map(function (item) {
          try {
            const rawHref =
              item && item.href
                ? item.href
                : buildFinalCollectionUrl(item && item.urlToAdd ? item.urlToAdd : '');

            return {
              label: String(item && item.label ? item.label : ''),
              href: String(rawHref || ''),
              count: Number(item && typeof item.count !== 'undefined' ? item.count : 0) || 0
            };
          } catch (e) {
            logErr('writeDynamicMenuCategorySnapshotForGender.mapItem', e);
            return null;
          }
        })
        .filter(function (item) {
          return !!(item && item.label && item.href);
        })
    };

    if (!snapshot.genders[genderKey].items.length) {
      delete snapshot.genders[genderKey];
    }

    window.sessionStorage.setItem(
      SOV_DYNAMIC_MENU_CATEGORY_SNAPSHOT_KEY,
      JSON.stringify(snapshot));
  } catch (e) {
    logErr('writeDynamicMenuCategorySnapshotForGender', e);
  }
}

function hydrateDynamicMenuCategoriesFromSavedSnapshot(hostUl) {
  try {
    const stateSnapshot =
      readDynamicMenuStateSnapshot();

    if (
      !stateSnapshot ||
      stateSnapshot.active_view !== 'gender' ||
      !stateSnapshot.active_gender_key ||
      !hostUl
    ) {
      return false;
    }

    const genderKey =
      String(stateSnapshot.active_gender_key || '').trim();

    const categorySnapshot =
      readDynamicMenuCategorySnapshotForGender(genderKey);

    if (!categorySnapshot) {
      return false;
    }

    const selector =
      'details[data-sov-gender-key="' + genderKey.replace(/"/g, '\\"') + '"]';

    const detailsEl =
      hostUl.querySelector(selector);

    if (!detailsEl) {
      return false;
    }

    const rootLi =
      detailsEl.closest('li');

    if (rootLi) {
      rootLi.hidden = false;
    }

    const innerSub =
      detailsEl.querySelector('.menu-drawer__inner-submenu');

    if (!innerSub) {
      return false;
    }

    const catsPanel =
      innerSub.querySelector('[data-sov-cats-panel]');

    const catsHost =
      innerSub.querySelector('[data-sov-cats-host]');

    const catsTitleEl =
      innerSub.querySelector('[data-sov-cats-title]');

    if (!catsPanel || !catsHost) {
      return false;
    }

    if (
      catsHost.getAttribute('data-loaded') === '1' &&
      catsHost.getAttribute('data-sov-snapshot-loaded') !== '1'
    ) {
      return true;
    }

    clearChildren(catsHost);

    if (catsTitleEl && categorySnapshot.category_title) {
      catsTitleEl.textContent =
        String(categorySnapshot.category_title);
    }

    categorySnapshot.items.forEach(function (item) {
      try {
        const categoryElement =
          cloneTpl(
            CFG.tplCategory,
            {
              HREF: item.href,
              LABEL: item.label,
              COUNT: item.count | 0
            });

        if (!categoryElement) {
          return;
        }

        const categoryLink =
          categoryElement.querySelector('a');

        if (categoryLink) {
          categoryLink.setAttribute(
            'href',
            item.href);
        }

        catsHost.appendChild(categoryElement);
      } catch (e) {
        logErr('hydrateDynamicMenuCategoriesFromSavedSnapshot.each', e);
      }
    });

    catsHost.setAttribute('data-loaded', '1');
    catsHost.setAttribute('data-sov-snapshot-loaded', '1');

    initDynamicMenuPanels(innerSub);
    openDynamicMenuPanel(catsPanel);
    refreshDynamicMenuPanel(catsPanel);
    refreshDynamicMenuPanels(innerSub);

    try {
      const rootDrawer =
        document.getElementById('Details-menu-drawer-container');

      if (rootDrawer && rootDrawer.open) {
        prepareDynamicMenuStateBeforeRootDrawerOpens(hostUl);
      }
    } catch (restoreError) {
      logErr('hydrateDynamicMenuCategoriesFromSavedSnapshot.restoreIfOpen', restoreError);
    }

    return true;
  } catch (e) {
    logErr('hydrateDynamicMenuCategoriesFromSavedSnapshot', e);
    return false;
  }
}

function getDynamicMenuPanelKey(panel) {
  try {
    return String(
      panel && panel.getAttribute('data-sov-dm-panel')
        ? panel.getAttribute('data-sov-dm-panel')
        : 'categories'
    ).trim();
  } catch (e) {
    logErr('getDynamicMenuPanelKey', e);
    return 'categories';
  }
}

function getOpenDynamicMenuPanelKey(container) {
  try {
    const scope = container || document;
    const openPanel = scope.querySelector('.sov-dm-panel[data-sov-dm-open="true"]');

    if (openPanel) {
      return getDynamicMenuPanelKey(openPanel);
    }

    return 'categories';
  } catch (e) {
    logErr('getOpenDynamicMenuPanelKey', e);
    return 'categories';
  }
}

function saveDynamicMenuStateFromGenderRoot(detailsEl, preferredPanelKey) {
  try {
    if (!detailsEl || !detailsEl.open) {
      return;
    }

    const genderKey =
      String(detailsEl.getAttribute('data-sov-gender-key') || '').trim();

    if (!genderKey) {
      return;
    }

    const innerSub =
      detailsEl.querySelector('.menu-drawer__inner-submenu');

    writeDynamicMenuStateSnapshot({
      active_view: 'gender',
      active_gender_key: genderKey,
      active_panel_key: preferredPanelKey || getOpenDynamicMenuPanelKey(innerSub)
    });
  } catch (e) {
    logErr('saveDynamicMenuStateFromGenderRoot', e);
  }
}

function saveDynamicMenuStateFromPanel(panel) {
  try {
    if (!panel || !getDynamicMenuPanelExpandedState(panel)) {
      return;
    }

    const detailsEl =
      panel.closest('details[data-sov-gender-key]');

    if (!detailsEl) {
      return;
    }

    writeDynamicMenuStateSnapshot({
      active_view: 'gender',
      active_gender_key: String(detailsEl.getAttribute('data-sov-gender-key') || '').trim(),
      active_panel_key: getDynamicMenuPanelKey(panel)
    });
  } catch (e) {
    logErr('saveDynamicMenuStateFromPanel', e);
  }
}

function saveDynamicMenuRootStateSnapshot() {
  try {
    writeDynamicMenuStateSnapshot({
      active_view: 'root',
      active_gender_key: '',
      active_panel_key: 'root',
      active_brand_slug: ''
    });
  } catch (e) {
    logErr('saveDynamicMenuRootStateSnapshot', e);
  }
}

function wireDynamicMenuGenderRootStatePersistence(detailsEl) {
  try {
    if (!detailsEl || detailsEl.__sovDynamicMenuRootStatePersistenceWired === true) {
      return;
    }

    detailsEl.__sovDynamicMenuRootStatePersistenceWired = true;

    const innerSub =
      detailsEl.querySelector(':scope > .menu-drawer__submenu > .menu-drawer__inner-submenu');

    const backButton =
      innerSub
        ? innerSub.querySelector(':scope > .menu-drawer__close-button')
        : detailsEl.querySelector('.menu-drawer__close-button');

    if (backButton) {
      backButton.addEventListener(
        'click',
        function () {
          saveDynamicMenuRootStateSnapshot();
        },
        {
          capture: true
        }
      );
    }

    detailsEl.addEventListener('toggle', function () {
      try {
        if (sovDynamicMenuStateRestoreInProgress || detailsEl.open) {
          return;
        }

        window.setTimeout(function () {
          try {
            const hostUl =
              detailsEl.closest('ul.menu-drawer__menu[data-sov-inject="primary"]');

            const openedGenderDetails =
              hostUl
                ? hostUl.querySelector(':scope > li > details[data-sov-gender-key][open]')
                : null;

            if (!openedGenderDetails) {
              saveDynamicMenuRootStateSnapshot();
            }
          } catch (e) {
            logErr('wireDynamicMenuGenderRootStatePersistence.toggle.defer', e);
          }
        }, 80);
      } catch (e) {
        logErr('wireDynamicMenuGenderRootStatePersistence.toggle', e);
      }
    });
  } catch (e) {
    logErr('wireDynamicMenuGenderRootStatePersistence', e);
  }
}

function getDynamicMenuGenderKeyFromCurrentUrl() {
  try {
    const params =
      new URLSearchParams(window.location.search || '');

    const genderParamMap = {
      'filter.p.m.custom.for_her': 'for_her',
      'filter.p.m.custom.for_him': 'for_him',
      'filter.p.m.custom.for_home': 'for_home'
    };

    const paramNames =
      Object.keys(genderParamMap);

    for (let i = 0; i < paramNames.length; i++) {
      const paramName =
        paramNames[i];

      const paramValue =
        String(params.get(paramName) || '').toLowerCase();

      if (paramValue === '1' || paramValue === 'true') {
        return genderParamMap[paramName];
      }
    }

    return '';
  } catch (e) {
    logErr('getDynamicMenuGenderKeyFromCurrentUrl', e);
    return '';
  }
}

function synchronizeDynamicMenuStateFromCurrentUrl() {
  try {
    const currentSnapshot =
      readDynamicMenuStateSnapshot();

    if (currentSnapshot && currentSnapshot.active_view === 'root') {
      return;
    }

    const genderKey =
      getDynamicMenuGenderKeyFromCurrentUrl();

    if (!genderKey) {
      return;
    }

    writeDynamicMenuStateSnapshot({
      active_view: 'gender',
      active_gender_key: genderKey,
      active_panel_key: 'categories'
    });
  } catch (e) {
    logErr('synchronizeDynamicMenuStateFromCurrentUrl', e);
  }
}

function restoreDynamicMenuStateWithNativeDrawerController(hostUl) {
  const snapshot =
    readDynamicMenuStateSnapshot();

  if (!snapshot || !hostUl || snapshot.active_view === 'root') {
    return;
  }

  const activeGenderKey =
    String(snapshot.active_gender_key || '').trim();

  if (!activeGenderKey) {
    return;
  }

  const selector =
    'details[data-sov-gender-key="' + activeGenderKey.replace(/"/g, '\\"') + '"]';

  const detailsEl =
    hostUl.querySelector(selector);

  if (!detailsEl) {
    return;
  }

  const innerSub =
    detailsEl.querySelector('.menu-drawer__inner-submenu');

  if (!innerSub) {
    return;
  }

  const categoriesPanel =
    innerSub.querySelector('[data-sov-dm-panel="categories"]');

  const categoriesHost =
    innerSub.querySelector('[data-sov-cats-host]');

  if (
    categoriesPanel &&
    categoriesHost &&
    categoriesHost.getAttribute('data-loaded') !== '1'
  ) {
    return;
  }

  const drawerElement =
    detailsEl.closest('header-drawer, menu-drawer') ||
    document.querySelector('header-drawer, menu-drawer');

  if (
    !drawerElement ||
    typeof drawerElement.openSubmenuFromSavedState !== 'function'
  ) {
    return;
  }

  try {
    sovDynamicMenuStateRestoreInProgress = true;

    const activePanelKey =
      String(snapshot.active_panel_key || 'categories').trim();

    const brandsPanel =
      innerSub.querySelector('[data-sov-dm-panel="brands"]');

    const restored =
      drawerElement.openSubmenuFromSavedState(
        detailsEl,
        {
          manageFocus: false
        }
      );

    if (!restored) {
      return;
    }

    initDynamicMenuPanels(innerSub);

    if (activePanelKey === 'brands' && brandsPanel) {
      if (categoriesPanel) {
        closeDynamicMenuPanel(categoriesPanel);
      }

      openDynamicMenuPanel(brandsPanel);
    } else {
      if (brandsPanel) {
        closeDynamicMenuPanel(brandsPanel);
      }

      if (categoriesPanel) {
        openDynamicMenuPanel(categoriesPanel);
      }
    }

    refreshDynamicMenuPanels(innerSub);
  } catch (e) {
    logErr('restoreDynamicMenuStateWithNativeDrawerController', e);
  } finally {
    window.setTimeout(function () {
      sovDynamicMenuStateRestoreInProgress = false;
    }, 360);
  }
}

function prepareDynamicMenuStateBeforeRootDrawerOpens(hostUl) {
  restoreDynamicMenuStateWithNativeDrawerController(hostUl);
  return;

  const snapshot =
    readDynamicMenuStateSnapshot();

  if (!snapshot || !hostUl || snapshot.active_view === 'root') {
    return;
  }

  const activeGenderKey =
    String(snapshot.active_gender_key || '').trim();

  if (!activeGenderKey) {
    return;
  }

  const selector =
    'details[data-sov-gender-key="' + activeGenderKey.replace(/"/g, '\\"') + '"]';

  const detailsEl =
    hostUl.querySelector(selector);

  if (!detailsEl) {
    return;
  }

  const innerSub =
    detailsEl.querySelector('.menu-drawer__inner-submenu');

  if (!innerSub) {
    return;
  }

  function isPreparedGenderReady() {
    try {
      const catsHost =
        innerSub.querySelector('[data-sov-cats-host]');

      const categoriesPanel =
        innerSub.querySelector('[data-sov-dm-panel="categories"]');

      if (!categoriesPanel) {
        return true;
      }

      return !!(catsHost && catsHost.getAttribute('data-loaded') === '1');
    } catch (e) {
      logErr('prepareDynamicMenuStateBeforeRootDrawerOpens.isPreparedGenderReady', e);
      return false;
    }
  }

  function removeDynamicSubmenuInlineState(submenu) {
    try {
      if (!submenu) {
        return;
      }

      submenu.style.removeProperty('position');
      submenu.style.removeProperty('inset');
      submenu.style.removeProperty('top');
      submenu.style.removeProperty('right');
      submenu.style.removeProperty('bottom');
      submenu.style.removeProperty('left');
      submenu.style.removeProperty('width');
      submenu.style.removeProperty('height');
      submenu.style.removeProperty('transition');
      submenu.style.removeProperty('transform');
      submenu.style.removeProperty('will-change');
    } catch (e) {
      logErr('prepareDynamicMenuStateBeforeRootDrawerOpens.removeDynamicSubmenuInlineState', e);
    }
  }

  function closeSiblingGenderDetailsForPreparedRestore() {
    try {
      hostUl.querySelectorAll(':scope > li > details[open]').forEach(function (openDetails) {
        if (openDetails === detailsEl) {
          return;
        }

        const openSummary =
          openDetails.querySelector(':scope > summary');

        const openSubmenu =
          openDetails.querySelector('.menu-drawer__submenu');

        openDetails.open = false;
        openDetails.classList.remove('menu-opening');

        if (openSummary) {
          openSummary.setAttribute('aria-expanded', 'false');
        }

        if (openSubmenu) {
          openSubmenu.style.visibility = 'hidden';
          removeDynamicSubmenuInlineState(openSubmenu);
        }
      });
    } catch (e) {
      logErr('prepareDynamicMenuStateBeforeRootDrawerOpens.closeSiblingGenderDetailsForPreparedRestore', e);
    }
  }

  function applyPreparedPanelState() {
    try {
      initDynamicMenuPanels(innerSub);

      const activePanelKey =
        String(snapshot.active_panel_key || 'categories').trim();

      const categoriesPanel =
        innerSub.querySelector('[data-sov-dm-panel="categories"]');

      const brandsPanel =
        innerSub.querySelector('[data-sov-dm-panel="brands"]');

      if (activePanelKey === 'brands' && brandsPanel) {
        if (categoriesPanel) {
          closeDynamicMenuPanel(categoriesPanel);
        }

        openDynamicMenuPanel(brandsPanel);
      } else {
        if (brandsPanel) {
          closeDynamicMenuPanel(brandsPanel);
        }

        if (categoriesPanel) {
          openDynamicMenuPanel(categoriesPanel);
        }
      }

      refreshDynamicMenuPanels(innerSub);
    } catch (e) {
      logErr('prepareDynamicMenuStateBeforeRootDrawerOpens.applyPreparedPanelState', e);
    }
  }

  function synchronizeDrawerHeightForPreparedSubmenu() {
    try {
      const rootDrawer =
        document.getElementById('Details-menu-drawer-container');

      const container =
        detailsEl.closest('.menu-drawer__inner-container');

      const nav =
        container ? container.querySelector('.menu-drawer__navigation') : null;

      const submenu =
        detailsEl.querySelector('.menu-drawer__submenu');

      const heightSource =
        innerSub || submenu;

      const measuredHeight =
        heightSource ? heightSource.scrollHeight : 0;

      if (nav && measuredHeight > 0) {
        nav.style.setProperty(
          '--menu-drawer-content-height',
          measuredHeight + 'px');
      }

      if (container && measuredHeight > 0) {
        container.style.height =
          measuredHeight + 'px';
      }

      if (rootDrawer && rootDrawer.open) {
        rootDrawer.classList.add('menu-opening');
      }
    } catch (e) {
      logErr('prepareDynamicMenuStateBeforeRootDrawerOpens.synchronizeDrawerHeightForPreparedSubmenu', e);
    }
  }

  if (!isPreparedGenderReady()) {
    return;
  }

  try {
    sovDynamicMenuStateRestoreInProgress = true;

    closeSiblingGenderDetailsForPreparedRestore();

    detailsEl.open = true;
    detailsEl.classList.add('menu-opening');

    const summary =
      detailsEl.querySelector(':scope > summary');

    const submenu =
      detailsEl.querySelector('.menu-drawer__submenu');

    if (summary) {
      summary.setAttribute('aria-expanded', 'true');
    }

    if (submenu) {
      removeDynamicSubmenuInlineState(submenu);
      submenu.style.visibility = 'visible';
    }

    hostUl.classList.add('submenu-open');

    applyPreparedPanelState();
    synchronizeDrawerHeightForPreparedSubmenu();

    window.requestAnimationFrame(function () {
      applyPreparedPanelState();
      synchronizeDrawerHeightForPreparedSubmenu();
    });

    window.setTimeout(function () {
      applyPreparedPanelState();
      synchronizeDrawerHeightForPreparedSubmenu();
    }, 120);
  } catch (e) {
    logErr('prepareDynamicMenuStateBeforeRootDrawerOpens', e);
  } finally {
    window.setTimeout(function () {
      sovDynamicMenuStateRestoreInProgress = false;
    }, 360);
  }
}

/* ============================
   preload categorie dopo page load
   -ultimo aggiornamento: 2026-06-12 18:45 europe/rome
   prima: le categorie venivano scaricate e renderizzate solo al toggle del root gender
   dopo: le categorie vengono precaricate in background dopo window.load, lasciando priorità al caricamento pagina
============================ */
function scheduleDynamicMenuCategoryPreloadAfterPageLoaded(hostUl) {
  try {
    if (!hostUl || hostUl.__sovDmCategoryPreloadScheduled === true) {
      return;
    }

    hostUl.__sovDmCategoryPreloadScheduled = true;

    const scheduleIdlePreload = function () {
      const runPreload = function () {
        preloadDynamicMenuCategoryPanelsInBackground(hostUl);
      };

      if (typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(
          runPreload,
          {
            timeout: 4000
          }
        );

        return;
      }

      window.setTimeout(
        runPreload,
        600
      );
    };

    if (document.readyState === 'complete') {
      scheduleIdlePreload();
      return;
    }

    window.addEventListener(
      'load',
      scheduleIdlePreload,
      {
        once: true
      }
    );
  } catch (e) {
    logErr('scheduleDynamicMenuCategoryPreloadAfterPageLoaded', e);
  }
}

function preloadDynamicMenuCategoryPanelsInBackground(hostUl) {
  try {
    if (!hostUl || hostUl.__sovDmCategoryPreloadRunning === true) {
      return;
    }

    hostUl.__sovDmCategoryPreloadRunning = true;

    const genderDetailsQueue =
      Array.prototype.slice
        .call(hostUl.querySelectorAll('[data-sov-gender-root-li="1"] details[data-sov-gender-key]'))
        .filter(function (detailsEl) {
          try {
            if (!detailsEl || detailsEl.hidden) {
              return false;
            }

            const genderEntry = detailsEl.__sovGenderEntry || null;
            const innerSub = detailsEl.querySelector('.menu-drawer__inner-submenu');
            const catsHost = innerSub ? innerSub.querySelector('[data-sov-cats-host]') : null;

            return !!(
              genderEntry &&
              !genderEntry.disabled &&
              (genderEntry.count | 0) > 0 &&
              genderEntry.urlToAdd &&
              catsHost &&
              (
                catsHost.getAttribute('data-loaded') !== '1' ||
                catsHost.getAttribute('data-sov-snapshot-loaded') === '1'
              )
            );
          } catch (e) {
            logErr('preloadDynamicMenuCategoryPanelsInBackground.filter', e);
            return false;
          }
        });

    const runNext = function () {
      try {
        const detailsEl = genderDetailsQueue.shift();

        if (!detailsEl) {
          hostUl.__sovDmCategoryPreloadRunning = false;
          return;
        }

        preloadDynamicMenuCategoriesForGenderRoot(detailsEl)
          .finally(function () {
            window.setTimeout(
              runNext,
              80
            );
          });
      } catch (e) {
        hostUl.__sovDmCategoryPreloadRunning = false;
        logErr('preloadDynamicMenuCategoryPanelsInBackground.runNext', e);
      }
    };

    runNext();
  } catch (e) {
    if (hostUl) {
      hostUl.__sovDmCategoryPreloadRunning = false;
    }

    logErr('preloadDynamicMenuCategoryPanelsInBackground', e);
  }
}

function preloadDynamicMenuCategoriesForGenderRoot(detailsEl) {
  try {
    if (!detailsEl) {
      return Promise.resolve();
    }

    const genderEntry = detailsEl.__sovGenderEntry || null;
    const innerSub = detailsEl.querySelector('.menu-drawer__inner-submenu');
    const catsPanel = innerSub ? innerSub.querySelector('[data-sov-cats-panel]') : null;
    const catsHost = innerSub ? innerSub.querySelector('[data-sov-cats-host]') : null;
    const catsTitleEl = innerSub ? innerSub.querySelector('[data-sov-cats-title]') : null;

    if (
      !genderEntry ||
      genderEntry.disabled ||
      !genderEntry.urlToAdd ||
      !catsPanel ||
      !catsHost ||
      (
        catsHost.getAttribute('data-loaded') === '1' &&
        catsHost.getAttribute('data-sov-snapshot-loaded') !== '1'
      )
    ) {
      return Promise.resolve();
    }

    return getGenderJsonPromise(genderEntry.urlToAdd)
      .then(function (json) {
        try {
          const catParam =
            (json && json.hints && json.hints.category_param_name) ||
            'filter.p.t.category';

          const catFilter =
            findFilterByParamName(
              json,
              catParam);

          if (catsTitleEl && catFilter && catFilter.label) {
            catsTitleEl.textContent =
              String(catFilter.label);
          }

          return listCategoriesForGenderFromJson(json);
        } catch (e) {
          logErr('preloadDynamicMenuCategoriesForGenderRoot.json', e);
          return [];
        }
      })
      .then(function (items) {
        try {
          clearChildren(catsHost);
          catsHost.setAttribute('data-loaded', '1');
          catsHost.removeAttribute('data-sov-snapshot-loaded');

          if (!items || !items.length) {
            if (catsPanel && catsPanel.parentNode) {
              catsPanel.parentNode.removeChild(catsPanel);
            }

            return;
          }

          writeDynamicMenuCategorySnapshotForGender(
            detailsEl,
            items,
            catsTitleEl ? catsTitleEl.textContent : '');

          items.forEach(function (it) {
            try {
              const categoryElement = cloneTpl(
                CFG.tplCategory,
                {
                  HREF: buildFinalCollectionUrl(it.urlToAdd),
                  LABEL: it.label,
                  COUNT: it.count | 0
                });

              if (!categoryElement) {
                return;
              }

              const categoryLink = categoryElement.querySelector('a');

              if (categoryLink) {
                categoryLink.setAttribute(
                  'href',
                  buildFinalCollectionUrl(it.urlToAdd));
              }

              catsHost.appendChild(categoryElement);
            } catch (e) {
              logErr('preloadDynamicMenuCategoriesForGenderRoot.each', e);
            }
          });

          openDynamicMenuPanel(catsPanel);
          refreshDynamicMenuPanel(catsPanel);

          try {
            const rootDrawer =
              document.getElementById('Details-menu-drawer-container');

            const host =
              document.querySelector(CFG.injectHostSelector);

            if (rootDrawer && rootDrawer.open && host) {
              prepareDynamicMenuStateBeforeRootDrawerOpens(host);
            }
          } catch (restoreError) {
            logErr('preloadDynamicMenuCategoriesForGenderRoot.nativeRestoreAfterPreload', restoreError);
          }
        } catch (e) {
          logErr('preloadDynamicMenuCategoriesForGenderRoot.render', e);
        }
      })
      .catch(function (e) {
        logErr('preloadDynamicMenuCategoriesForGenderRoot.catch', e);
      });
  } catch (e) {
    logErr('preloadDynamicMenuCategoriesForGenderRoot', e);
    return Promise.resolve();
  }
}

  /* ============================
     mount: genera i 3 livelli
     ============================ */
function hydrateExistingGenderRoots(hostUl, genders) {
  try {
    const genderMap = Object.create(null);

    (genders || []).forEach(function (g) {
      if (g && g.key) {
        genderMap[g.key] = g;
      }
    });

    function removeNode(node) {
      if (node && node.parentNode) {
        node.parentNode.removeChild(node);
      }
    }

    function setGenderLabels(detailsEl, labelText) {
      if (!detailsEl || !labelText) {
        return;
      }

      Array.prototype.slice
        .call(detailsEl.querySelectorAll('[data-sov-gender-label]'))
        .forEach(function (node) {
          node.textContent = String(labelText);
        });
    }

    function wireInnerPanelsAccordion(container) {
      try {
        if (!container || container.dataset.sovInnerAccordionWired === 'true') {
          return;
        }

        container.dataset.sovInnerAccordionWired = 'true';

        container.addEventListener(
          'click',
          function (ev) {
            const header = ev.target.closest('.sov-dm-head');

            if (!header || !container.contains(header)) {
              return;
            }

            const pane = header.closest('.sov-dm-panel');

            if (!pane) {
              return;
            }

            const isOpen = getDynamicMenuPanelExpandedState(pane);

            if (!isOpen) {
              container.querySelectorAll('.sov-dm-panel[data-sov-dm-open="true"]').forEach(function (p) {
                if (p === pane) {
                  return;
                }

                closeDynamicMenuPanel(p);
              });
            }
          },
          { capture: true }
        );
      } catch (e) {
        logErr('hydrateExistingGenderRoots.wireInnerPanelsAccordion', e);
      }
    }

    Array.prototype.slice
      .call(hostUl.querySelectorAll('[data-sov-gender-root-li="1"]'))
      .forEach(function (li) {
        try {
          const details = li.querySelector('details[data-sov-gender-key]');
          if (!details) {
            return;
          }

          const genderKey = details.getAttribute('data-sov-gender-key') || '';
          const g = genderMap[genderKey] || null;

          const manualLinksGroup = details.querySelector('[data-sov-manual-links-group]');
          const manualLinksHost = details.querySelector('[data-sov-manual-links-host]');
          const summary = details.querySelector('summary');

          const innerSub = details.querySelector('.menu-drawer__inner-submenu');
          const statusGender = details.querySelector('[data-sov-status]');

          let catsPanel = innerSub ? innerSub.querySelector('[data-sov-cats-panel]') : null;
          let brandsPanel = innerSub ? innerSub.querySelector('[data-sov-brands-panel]') : null;
          let catsHost = innerSub ? innerSub.querySelector('[data-sov-cats-host]') : null;
          let brandsHost = innerSub ? innerSub.querySelector('[data-sov-brands-host]') : null;
          let catsTitleEl = innerSub ? innerSub.querySelector('[data-sov-cats-title]') : null;
          let brandsTitleEl = innerSub ? innerSub.querySelector('[data-sov-brands-title]') : null;

          const hasManualItems =
            !!manualLinksHost && manualLinksHost.children && manualLinksHost.children.length > 0;

          const hasDynamicFacetItems =
            !!(g && !g.disabled && (g.count | 0) > 0 && g.urlToAdd);

          details.__sovGenderEntry =
            g;

          details.__sovGenderHasDynamicFacetItems =
            hasDynamicFacetItems;

          if (!hasManualItems && !hasDynamicFacetItems) {
            removeNode(li);
            return;
          }

          li.hidden = false;

          if (manualLinksGroup) {
            manualLinksGroup.hidden = !hasManualItems;
          }

          if (g && g.label) {
            setGenderLabels(details, g.label);
          }

          if (!hasDynamicFacetItems) {
            removeNode(catsPanel);
            removeNode(brandsPanel);
            catsPanel = null;
            brandsPanel = null;
            catsHost = null;
            brandsHost = null;
            catsTitleEl = null;
            brandsTitleEl = null;
          }

          if (window.SHOW_VENDORS === false) {
            removeNode(brandsPanel);
            brandsPanel = null;
            brandsHost = null;
            brandsTitleEl = null;
          }

          initDynamicMenuPanels(innerSub);

          openDynamicMenuCategoriesPanel(innerSub);

          wireInnerPanelsAccordion(innerSub);

          if (details.dataset.sovGenderRootInit !== 'true') {
            observeDetailsToggle(details, 'drawer_gender', function () {
              const labelNode = details.querySelector('[data-sov-gender-label]');
              return labelNode ? (labelNode.textContent || '').trim() : genderKey;
            });

            wireAria(details);
            wireBackExitAnimation(details);
            fixOnOpen(details);
            wireDynamicMenuGenderRootStatePersistence(details);

            details.addEventListener('toggle', function () {
              try {
                if (!details.open) {
                  return;
                }

                if (sovDynamicMenuStateRestoreInProgress) {
                  openDynamicMenuCategoriesPanel(innerSub);
                  refreshDynamicMenuPanels(innerSub);
                  return;
                }

                openRootDrawerIfClosed();

                openDynamicMenuCategoriesPanel(innerSub);
                refreshDynamicMenuPanels(innerSub);

                saveDynamicMenuStateFromGenderRoot(
                  details,
                  'categories');

                if (!hasDynamicFacetItems) {
                  return;
                }

                const catsAlreadyLoaded =
                  !catsHost || catsHost.getAttribute('data-loaded') === '1';

                const brandsAlreadyLoaded =
                  window.SHOW_VENDORS === false ||
                  !brandsHost ||
                  brandsHost.getAttribute('data-loaded') === '1';

                if (catsAlreadyLoaded && brandsAlreadyLoaded) {
                  openDynamicMenuCategoriesPanel(innerSub);
                  refreshDynamicMenuPanels(innerSub);
                  log('gender cached:', genderKey);
                  return;
                }

                showStatus(statusGender);

                const sp = null;

                const genderJsonPromise = getGenderJsonPromise(g.urlToAdd);
                const tasks = [];

                tasks.push(
                  genderJsonPromise.then(function (json) {
                    try {
                      const brandParam =
                        (json && json.hints && json.hints.brand_param_name) || 'filter.p.vendor';
                      const catParam =
                        (json && json.hints && json.hints.category_param_name) || 'filter.p.t.category';

                      const brandFilter = findFilterByParamName(json, brandParam);
                      const catFilter = findFilterByParamName(json, catParam);

                      if (catsTitleEl && catFilter && catFilter.label) {
                        catsTitleEl.textContent = String(catFilter.label);
                      }

                      if (
                        window.SHOW_VENDORS !== false &&
                        brandsTitleEl &&
                        brandFilter &&
                        brandFilter.label
                      ) {
                        brandsTitleEl.textContent = String(brandFilter.label);
                      }

                      if (catsHost && catsHost.getAttribute('data-loaded') !== '1') {
                        return listCategoriesForGenderFromJson(json).then(function (items) {
                          try {
                            clearChildren(catsHost);
                            catsHost.setAttribute('data-loaded', '1');
                            catsHost.removeAttribute('data-sov-snapshot-loaded');

                            if (!items.length) {
                              removeNode(catsPanel);
                              catsPanel = null;
                              catsHost = null;
                              catsTitleEl = null;
                              return;
                            }

                            writeDynamicMenuCategorySnapshotForGender(
                              details,
                              items,
                              catsTitleEl ? catsTitleEl.textContent : '');

                            items.forEach(function (it) {
                              try {
                                const ce = cloneTpl(CFG.tplCategory, {
                                  HREF: buildFinalCollectionUrl(it.urlToAdd),
                                  LABEL: it.label,
                                  COUNT: it.count | 0,
                                });

                                if (!ce) {
                                  return;
                                }

                                const a = ce.querySelector('a');
                                if (a) {
                                  a.setAttribute('href', buildFinalCollectionUrl(it.urlToAdd));
                                }

                                catsHost.appendChild(ce);
                              } catch (e) {
                                logErr('hydrateExistingGenderRoots.genderCategories.each', e);
                              }
                            });

                            openDynamicMenuPanel(catsPanel);
                            refreshDynamicMenuPanel(catsPanel);
                          } catch (e) {
                            logErr('hydrateExistingGenderRoots.genderCategories.render', e);
                          }
                        });
                      }
                    } catch (e) {
                      logErr('hydrateExistingGenderRoots.genderJson.then', e);
                    }

                    return null;
                  })
                );

                if (window.SHOW_VENDORS !== false && brandsHost && brandsPanel) {
                  tasks.push(
                    listBrandsForGender(g.urlToAdd).then(function (brands) {
                      try {
                        clearChildren(brandsHost);
                        brandsHost.setAttribute('data-loaded', '1');

                        if (!brands.length) {
                          removeNode(brandsPanel);
                          brandsPanel = null;
                          brandsHost = null;
                          brandsTitleEl = null;
                          return;
                        }

                        brands.forEach(function (b) {
                          try {
                            const be = cloneTpl(CFG.tplBrand, {
                              SLUG: b.slug,
                              LABEL: b.label,
                              COUNT: b.count | 0,
                            });

                            if (!be) {
                              return;
                            }

                            const bDetails = be.querySelector('details');
                            const bSummary = be.querySelector('summary');
                            const brandCatsHost = be.querySelector('[data-sov-cats-host]');

                            observeDetailsToggle(bDetails, 'drawer_brand', b.label || '');

                            wireAria(bDetails);
                            wireBackExitAnimation(bDetails);
                            fixOnOpen(bDetails);

                            bDetails.addEventListener('toggle', function () {
                              try {
                                if (!bDetails.open) {
                                  return;
                                }

                                closeSiblingDetails(bDetails);

                                if (brandCatsHost.getAttribute('data-loaded') === '1') {
                                  log('brand cached:', b.label);
                                  return;
                                }

                                const statusBrand = be.querySelector('[data-sov-status]');
                                showStatus(statusBrand);

                                const spb = null;

                                listCategoriesForBrand(b.urlToAdd)
                                  .then(function (items) {
                                    try {
                                      clearChildren(brandCatsHost);
                                      brandCatsHost.setAttribute('data-loaded', '1');

                                      if (!items.length) {
                                        removeNode(be);
                                        return;
                                      }

                                      items.forEach(function (it) {
                                        try {
                                          const ce = cloneTpl(CFG.tplCategory, {
                                            HREF: buildFinalCollectionUrl(it.urlToAdd),
                                            LABEL: it.label,
                                            COUNT: it.count | 0,
                                          });

                                          if (!ce) {
                                            return;
                                          }

                                          const a = ce.querySelector('a');
                                          if (a) {
                                            a.setAttribute(
                                              'href',
                                              buildFinalCollectionUrl(it.urlToAdd)
                                            );
                                          }

                                          brandCatsHost.appendChild(ce);
                                        } catch (e) {
                                          logErr(
                                            'hydrateExistingGenderRoots.brandCategories.each',
                                            e
                                          );
                                        }
                                      });
                                    } catch (e) {
                                      logErr(
                                        'hydrateExistingGenderRoots.brandCategories.render',
                                        e
                                      );
                                    }
                                  })
                                  .finally(function () {

                                    hideStatus(statusBrand);
                                  });
                              } catch (e) {
                                logErr('hydrateExistingGenderRoots.brand.toggle', e);
                              }
                            });

                            brandsHost.appendChild(be);
                          } catch (e) {
                            logErr('hydrateExistingGenderRoots.brand.loop', e);
                          }
                        });
                      } catch (e) {
                        logErr('hydrateExistingGenderRoots.listBrandsForGender.then', e);
                      }
                    })
                  );
                }

                Promise.all(tasks).finally(function () {
                  openDynamicMenuCategoriesPanel(innerSub);
                  refreshDynamicMenuPanels(innerSub);

                  hideStatus(statusGender);
                  remountNativeHandlers();
                  ensureDelegatedToggleFallback();
                });
              } catch (e) {
                logErr('hydrateExistingGenderRoots.details.toggle', e);
              }
            });

            details.dataset.sovGenderRootInit = 'true';
          }
        } catch (e) {
          logErr('hydrateExistingGenderRoots.each', e);
        }
      });

    remountNativeHandlers();
    ensureDelegatedToggleFallback();
  } catch (e) {
    logErr('hydrateExistingGenderRoots.outer', e);
  }
}

  /* ============================
     bootstrap
     ============================ */
function initOnce(hostUl) {
  try {
    if (!hostUl || hostUl.__sovDynMenuInited) return;
    hostUl.__sovDynMenuInited = true;

    hydrateDynamicMenuCategoriesFromSavedSnapshot(hostUl);

    /* SOV facets distributor
       -Ultimo aggiornamento: 2025-09-22 16:45 Europe/Rome
       prima: resolveAllCollectionUrl() + fetchJsonWithCache(...)
       dopo:  SOV.facets.ensureRoot() (payload condiviso) con fallback a evento
    */
    if (window.SOV && SOV.facets && typeof SOV.facets.ensureRoot === 'function') {
      SOV.facets.ensureRoot()
        .then(function (rootJson) {
          try {
            log('root filters:', Array.isArray(rootJson.filters) ? rootJson.filters.length : -1);

            const genders = getGenderEntriesFromRoot(rootJson);
            const order = { for_her: 1, for_him: 2, for_home: 9 };
            genders.sort((a, b) => (order[a.key] || 99) - (order[b.key] || 99));

            hydrateExistingGenderRoots(hostUl, genders);
            synchronizeDynamicMenuStateFromCurrentUrl();
            hydrateDynamicMenuCategoriesFromSavedSnapshot(hostUl);
            scheduleDynamicMenuCategoryPreloadAfterPageLoaded(hostUl);
          } catch (e) { logErr('initOnce.then', e); }
        })
        .catch(function (e) { logErr('initOnce.ensureRoot.catch', e); });
    } else {
      log('SOV.facets non disponibile; attendo evento sov:facets:root:ready');
      document.addEventListener('sov:facets:root:ready', function (ev) {
        try {
          var rootJson = (ev && ev.detail && ev.detail.payload) || null;
          if (!rootJson) return;

          log('root filters:', Array.isArray(rootJson.filters) ? rootJson.filters.length : -1);
          const genders = getGenderEntriesFromRoot(rootJson);
          const order = { for_her: 1, for_him: 2, for_home: 9 };
          genders.sort((a, b) => (order[a.key] || 99) - (order[b.key] || 99));

          hydrateExistingGenderRoots(hostUl, genders);
          synchronizeDynamicMenuStateFromCurrentUrl();
          hydrateDynamicMenuCategoriesFromSavedSnapshot(hostUl);
          scheduleDynamicMenuCategoryPreloadAfterPageLoaded(hostUl);
        } catch (e) { logErr('initOnce.readyHandler', e); }
      }, { once: true });
    }
  } catch (e) { logErr('initOnce.outer', e); }
}


  function tryMount() {
    try {
      const host = document.querySelector(CFG.injectHostSelector);
      if (host) { 
        initOnce(host); 
        remountNativeHandlers(); 
        ensureDelegatedToggleFallback(); 
        wireRootDrawerTelemetry();
        return; }
      log('inject host non trovato:', CFG.injectHostSelector);
    } catch (e) {
      logErr('tryMount', e);
    }
  }

  try {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', tryMount, { once: true });
    } else {
      tryMount();
    }
  } catch (e) { logErr('bootstrap.readyState', e); }

  try {
    ['shopify:section:load', 'page:load'].forEach(function (ev) {
      document.addEventListener(ev, function () {
        try {
          const host = document.querySelector(CFG.injectHostSelector);
          if (host && !host.__sovDynMenuInited) tryMount();
        } catch (e) { logErr('globalListener(' + ev + ')', e); }
      });
    });
  } catch (e) { logErr('bootstrap.globalListeners', e); }
})();

